import { Query } from "@datorama/akita";
import { singleton } from "tsyringe";

import ShopifyDiscountStore, {
    ShopifyDiscountState,
} from "../store/ShopifyDiscountStore";

@singleton()
class ShopifyDiscountQuery extends Query<ShopifyDiscountState> {
    constructor(protected store: ShopifyDiscountStore) {
        super(store);
    }
    discountStatus$ = this.select((state) => state.discountStatus);
}

export default ShopifyDiscountQuery;
